module.exports = __webpack_public_path__ + "static/media/clam.2e16a9ba.jpg";